import { defineStore } from 'pinia'
import client from '../api/client.js'
import { useKeycloakStore } from './keycloak.js'

const grpDoc = (groupId, path, config) => client.get(`groups/${groupId}/documents${path}`, config)
const grpDocPost = (groupId, path, data, config) => client.post(`groups/${groupId}/documents${path}`, data, config)
const grpDocPatch = (groupId, docId, data, config) => client.patch(`groups/${groupId}/documents/${docId}`, data, config)
const grpDocDel = (groupId, docId, config) => client.delete(`groups/${groupId}/documents/${docId}`, config)

export const useDocumentsStore = defineStore('documents', {
  state: () => ({
    documents: [],
    totalElements: 0,
    loading: false,
    uploading: false,
    currentCategory: '',
  }),

  actions: {
    _userId() { return useKeycloakStore().subject || '' },

    async fetchDocuments(groupId, category = '') {
      this.loading = true
      try {
        const { data } = await grpDoc(groupId, '', { params: category ? { category } : {}, headers: { 'X-User-Id': this._userId() } })
        this.documents = data.content ?? data ?? []
        this.totalElements = data.totalElements ?? this.documents.length
      } catch (err) { this.documents = []; this.totalElements = 0; throw err } finally { this.loading = false }
    },

    async registerDocument(groupId, payload) {
      const { data } = await grpDocPost(groupId, '', payload); return data
    },

    async updateDocument(groupId, documentId, payload) {
      const { data } = await grpDocPatch(groupId, documentId, payload); return data
    },

    async deleteDocument(groupId, documentId) {
      await grpDocDel(groupId, documentId)
    },
  },
})
